export const isPaidUser = (user) => {
  return user?.role === "pre" && user?.payments > 0;
};

export const isUsageUser = (user) => {
  return user?.isUsages === true;
};
